export default __webpack_public_path__ + "502fc2c1568fed0510b408e1c7e03e68.svg";